import { render, staticRenderFns } from "./ProductRoles.vue?vue&type=template&id=59ff432e&"
import script from "./ProductRoles.vue?vue&type=script&lang=js&"
export * from "./ProductRoles.vue?vue&type=script&lang=js&"
import style0 from "./ProductRoles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VDataTable,VRow,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ff432e')) {
      api.createRecord('59ff432e', component.options)
    } else {
      api.reload('59ff432e', component.options)
    }
    module.hot.accept("./ProductRoles.vue?vue&type=template&id=59ff432e&", function () {
      api.rerender('59ff432e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/ProductRoles.vue"
export default component.exports